import { createGS1SearchExec } from "../utils";

export const lunaEMG = {
    name: "LunaEMG",
    execs: {
        elementSerialRegex: /^https?:\/\/i\.egzo\.tech\/5\/([0-9a-fA-F]{6})$/m,
        elementSerialRegexGs1: createGS1SearchExec([{ ai: "01", include: false }, { ai: "21", regex: /^([0-9a-fA-F]{6})$/ }]), // /^.*01\d{14}.*21([0-9a-fA-F]{6})$/m,
        elementSerialRegexPlain: /^([0-9a-fA-F]{6})$/m,
        elementGtinLot8DateRegexGs1: createGS1SearchExec([{ ai: "01" }, { ai: "10", regex: /^([0-9]{8})$/ }]), // /^.*01(\d{14}).*10([0-9]{8})$/m,
        elementGtinLotRegexGs1: createGS1SearchExec([{ ai: "01" }, { ai: "10" }]), // /^.*01(\d{14}).*10([0-9A-Za-z-_+=:]{1,20})/m,
        elementGtinLot8DateRegexPlain: /(\d{14})-([0-9]{8})/m,
        elementSerialUnknown: /^(.*)$/m,
    },
    get orderedExecs() {
        return [
            this.execs.elementSerialRegex,
            this.execs.elementSerialRegexGs1,
            this.execs.elementGtinLot8DateRegexGs1,
            this.execs.elementGtinLotRegexGs1,
            this.execs.elementSerialRegexPlain,
            this.execs.elementSerialUnknown
        ]
    },
    orderTypes: [
        "Luna EMG Standard",
        "Luna EMG Premium"
    ]
};

export const stellaBIO = {
    name: "StellaBIO",
    execs: {
        elementSerialRegex: /^https?:\/\/i\.egzo\.tech\/5\/([2-7A-Za-z]{8})$/m,
        elementSerialRegexGs1: createGS1SearchExec([{ ai: "01", include: false }, { ai: "21", regex: /^([2-7A-Za-z]{8})$/ }]), // /^.*01\d{14}.*21([2-7A-Za-z]{8})$/m,
        elementSerialRegexPlain: /^([2-7A-Za-z]{8})$/m,
        elementExternalSerialRegexPlain: /^([0-9A-Za-z-_:/]{4,20})$/m
    },
    get orderedExecs() {
        return [
            this.execs.elementSerialRegex,
            this.execs.elementSerialRegexGs1,
            this.execs.elementSerialRegexPlain,
            this.execs.elementExternalSerialRegexPlain
        ]
    },
    orderTypes: [
        "Stella BIO - EU Standard BOX",
        "Stella BIO - US Standard BOX",
        "Stella BIO - Internal",
    ]
};

export const mezosSIT = {
    name: "MezosSIT",
    execs: {
        elementSerialRegex: /^https?:\/\/i\.egzo\.tech\/5\/([2-7A-Za-z]{8})$/m,
        elementSerialRegexGs1: createGS1SearchExec([{ ai: "01", include: false }, { ai: "21", regex: /^([2-7A-Za-z]{8})$/ }]), // /^.*01\d{14}.*21([2-7A-Za-z]{8})$/m,
        elementSerialRegexPlain: /^([2-7A-Za-z]{8})$/m
    },
    get orderedExecs() {
        return [
            this.execs.elementSerialRegex,
            this.execs.elementSerialRegexGs1,
            this.execs.elementSerialRegexPlain,
        ]
    },
    orderTypes: [
        "Mezos SIT",
    ]
};

export const sidraLEG = {
    name: "SidraLEG",
    execs: {
        elementSerialRegex: /^https?:\/\/i\.egzo\.tech\/5\/([2-7A-Za-z]{8})$/m,
        elementSerialRegexGs1: createGS1SearchExec([{ ai: "01", include: false }, { ai: "21", regex: /^([2-7A-Za-z]{8})$/ }]), // /^.*01\d{14}.*21([2-7A-Za-z]{8})$/m,
        elementSerialRegexPlain: /^([2-7A-Za-z]{8})$/m
    },
    get orderedExecs() {
        return [
            this.execs.elementSerialRegex,
            this.execs.elementSerialRegexGs1,
            this.execs.elementSerialRegexPlain,
        ]
    },
    orderTypes: [
        "Sidra LEG Pro",
        "Sidra LEG Ultra",
    ]
};

export const meissaOT = {
    name: "MeiisaOT",
    execs: {
        elementSerialRegex: /^https?:\/\/i\.egzo\.tech\/5\/([2-7A-Za-z]{8})$/m,
        elementSerialRegexGs1: createGS1SearchExec([{ ai: "01", include: false }, { ai: "21", regex: /^([2-7A-Za-z]{8})$/ }]), // /^.*01\d{14}.*21([2-7A-Za-z]{8})$/m,
        elementSerialRegexPlain: /^([2-7A-Za-z]{8})$/m
    },
    get orderedExecs() {
        return [
            this.execs.elementSerialRegex,
            this.execs.elementSerialRegexGs1,
            this.execs.elementSerialRegexPlain,
        ]
    },
    orderTypes: [
        "Meissa OT Pro",
        "Meissa OT Ultra",
    ]
};


export const serial8Base32 = {
    name: "serial-8-base32",
    execs: {
        elementSerialRegex: /^https?:\/\/i\.egzo\.tech\/5\/([2-7A-Za-z]{8})$/m,
        elementSerialRegexGs1: createGS1SearchExec([{ ai: "01", include: false }, { ai: "21", regex: /^([2-7A-Za-z]{8})$/ }]), // /^.*01\d{14}.*21([2-7A-Za-z]{8})$/m,
        elementSerialRegexPlain: /^([2-7A-Za-z]{8})$/m,
    },
    get orderedExecs() {
        return [
            this.execs.elementSerialRegex,
            this.execs.elementSerialRegexGs1,
            this.execs.elementSerialRegexPlain
        ]
    },
}

export const serialNumberSearchExecs = [lunaEMG, stellaBIO];
